/* eslint-disable */

import React, { useEffect, useMemo, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import BtnGogo from '../../components/buttongoto/ButtonGoto';
import CardProduct from '../../components/card/card-product/CardProduct';
import ModalLoad from '../../components/modal/ModalLoad';
import ModalPopupMessage from '../../components/modal/ModalPopupMessage';
import AdBanner from '../../components/Adbanner/AdBanner';
import {
  computeLocationKey,
  useMarketPlaceQueries,
} from '../../hooks/useMarketPlaceQueries';
import './MarketPlace.css';

const LOCATION_CONFIG = [
  { id: 'filter-location-1', name: 'กรุงเทพมหานคร' },
  { id: 'filter-location-2', name: 'สมุทรปราการ' },
  { id: 'filter-location-3', name: 'นนทบุรี' },
  { id: 'filter-location-4', name: 'นครปฐม' },
  { id: 'filter-location-5', name: 'ปทุมธานี' },
];

function MarketPlace(props) {
  const isShopLoggedIn = props.permitdata && props.permitdata.role !== 'guest' && props.permitdata.token && props.permitdata.token !== '-';
  const isJobOnlyLoggedIn = sessionStorage.getItem('meya-job-loggedin') === 'true' && !isShopLoggedIn;

  const location = useLocation();
  let [searchParams, setSearchParams] = useSearchParams();

  const [locationFilters, setLocationFilters] = useState({
    'กรุงเทพมหานคร': false,
    'สมุทรปราการ': false,
    'นนทบุรี': false,
    'นครปฐม': false,
    'ปทุมธานี': false,
  });

  const handleLocationCheckboxChange = (name) => {
    setLocationFilters((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const [view_transaction, setView_transaction] = useState(0);
  const [view_defaultpaginate, setDefaultPaginate] = useState(-1);
  const [view_productcategory_name, setView_productcategory_name] = useState('-');
  const [view_searchtype_name, setView_searchtype_name] = useState('');
  const [view_productid_name, setView_productid_name] = useState('');
  const [view_searchtext_name, setView_searchtext_name] = useState('');
  const [view_location_trigger, setView_location_trigger] = useState(0);

  const [limit_promotion, setLimit_promotion] = useState({ max: 9, min: 0 });
  const [limit_bestseller, setLimit_bestseller] = useState({ max: 9, min: 0 });

  const [promotionPage, setPromotionPage] = useState(1);

  const [location_filter, setLocation_filter] = useState({
    p1: false,
    p2: false,
    p3: false,
    p4: false,
    p5: false,
  });

  const [fetchLocationKey, setFetchLocationKey] = useState('none');

  const [modal_load, setmodal_load] = useState({ enable: false, message: '' });
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });
  const [itemOffset_onsell, setItemOffset_onsell] = useState(0);

  const productCategoryId = useMemo(() => {
    if (!props.systemdata_productcategorylist?.length) return null;
    const found = props.systemdata_productcategorylist.find(
      (item) => item.productcategory_name === view_productcategory_name,
    );
    return found?.productcategory_id ?? null;
  }, [props.systemdata_productcategorylist, view_productcategory_name]);

  const locationKey = useMemo(
    () => `${fetchLocationKey}:${view_location_trigger}:${view_transaction}`,
    [fetchLocationKey, view_location_trigger, view_transaction],
  );

  const {
    multirandomQuery,
    categoryQuery,
    promotionQuery,
    adsQuery,
    searchContainQuery,
    searchProductIdQuery,
    activeQuery,
    isHome,
    isPromotion,
    isAdsView,
    isCategoryView,
    canBrowseCategory,
  } = useMarketPlaceQueries({
    permitdata: props.permitdata,
    buyerCategory: props.buyer_category,
    viewCategory: view_productcategory_name,
    searchType: view_searchtype_name,
    productId: view_productid_name,
    searchText: view_searchtext_name,
    productCategoryId,
    locationKey,
    locationFilters,
    promotionPage,
  });

  const dataitem_filter_promotion = multirandomQuery.data?.items_pro ?? [];
  const dataitem_filter_bestseller = multirandomQuery.data?.items_best ?? [];
  const promotionTotal = promotionQuery.data?.total ?? 0;
  const isHomeRefreshing = isHome && multirandomQuery.isFetching && !!multirandomQuery.data;

  const dataitem_all = useMemo(() => {
    if (isPromotion) return promotionQuery.data?.items ?? [];
    if (isAdsView) return adsQuery.data?.items ?? [];
    if (view_productcategory_name === 'ค้นหาสินค้า') {
      if (view_searchtype_name === 'contain') return searchContainQuery.data?.items ?? [];
      if (view_searchtype_name === 'productid') return searchProductIdQuery.data?.items ?? [];
    }
    if (isCategoryView) {
      if (!canBrowseCategory) return [];
      return categoryQuery.data?.items ?? [];
    }
    return [];
  }, [
    isPromotion,
    isAdsView,
    isCategoryView,
    canBrowseCategory,
    view_productcategory_name,
    view_searchtype_name,
    promotionQuery.data,
    adsQuery.data,
    searchContainQuery.data,
    searchProductIdQuery.data,
    categoryQuery.data,
  ]);

  const dataitem_filter_single = useMemo(() => {
    if (!view_productcategory_name || view_productcategory_name === '-' || view_productcategory_name === 'รวมสินค้า') {
      return [];
    }
    if (view_productcategory_name === 'สินค้าโปรโมชั่น') {
      return dataitem_all.filter((item) => Number(item.first_pricenew) > 0);
    }
    if (view_productcategory_name === 'สินค้าแนะนำ') {
      return dataitem_all.filter((item) => item.ads === true);
    }
    if (view_productcategory_name === 'ค้นหาสินค้า') {
      return dataitem_all;
    }
    const findcatid = props.systemdata_productcategorylist?.find(
      (item) => item.productcategory_name === view_productcategory_name,
    );
    const catid = findcatid?.productcategory_id ?? '';
    return dataitem_all.filter((item) => item.productcategory_id === catid);
  }, [
    view_productcategory_name,
    view_searchtype_name,
    view_productid_name,
    view_searchtext_name,
    props.systemdata_productcategorylist,
    dataitem_all,
  ]);

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) {}

  useEffect(() => {
    const category = searchParams.get('category');
    const searchtype = searchParams.get('searchtype');
    const productid = searchParams.get('productid');
    const detail = searchParams.get('detail');
    const transaction = searchParams.get('transaction');
    if (category != '') {
      setView_productcategory_name(category);
      setView_searchtype_name(searchtype);
      setView_productid_name(productid);
      setView_searchtext_name(detail);
      setView_transaction(transaction);
    }

    setItemOffset_onsell(0);
    setDefaultPaginate(0);
    setFetchLocationKey(computeLocationKey(locationFilters));
    setLocation_filter({
      p1: locationFilters['กรุงเทพมหานคร'],
      p2: locationFilters['สมุทรปราการ'],
      p3: locationFilters['นนทบุรี'],
      p4: locationFilters['นครปฐม'],
      p5: locationFilters['ปทุมธานี'],
    });
  }, [location]);

  useEffect(() => {
    if (view_productcategory_name === 'สินค้าโปรโมชั่น') {
      setPromotionPage(1);
    }
  }, [view_productcategory_name]);

  useEffect(() => {
    if (multirandomQuery.data) {
      setLimit_promotion({ max: 9, min: 0 });
      setLimit_bestseller({ max: 9, min: 0 });
    }
  }, [multirandomQuery.data]);

  useEffect(() => {
    if (!activeQuery) {
      setmodal_load({ enable: false, message: '' });
      return;
    }
    if (activeQuery.isFetching && !activeQuery.data) {
      setmodal_load({ enable: true, message: 'กำลังโหลดรายการสินค้า', transparent: true });
    } else {
      setmodal_load({ enable: false, message: '' });
    }
  }, [activeQuery]);

  useEffect(() => {
    if (!activeQuery) return;
    if (activeQuery.isError && !activeQuery.isFetching) {
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: activeQuery.error?.message ?? 'ผิดพลาด',
        enable: true,
      });
      return;
    }
    if (activeQuery.isSuccess) {
      setModal_popup((prev) =>
        prev.enable && prev.modaltype === 'modal-error'
          ? { modaltype: '', headers: '', message: '', enable: false }
          : prev,
      );
    }
  }, [
    activeQuery?.isError,
    activeQuery?.isFetching,
    activeQuery?.isSuccess,
    activeQuery?.errorUpdatedAt,
    activeQuery?.dataUpdatedAt,
  ]);

  function loacation_begin_trigger() {
    if (
      location_filter.p1 !== locationFilters['กรุงเทพมหานคร'] ||
      location_filter.p2 !== locationFilters['สมุทรปราการ'] ||
      location_filter.p3 !== locationFilters['นนทบุรี'] ||
      location_filter.p4 !== locationFilters['นครปฐม'] ||
      location_filter.p5 !== locationFilters['ปทุมธานี']
    ) {
      setLocation_filter({
        p1: locationFilters['กรุงเทพมหานคร'],
        p2: locationFilters['สมุทรปราการ'],
        p3: locationFilters['นนทบุรี'],
        p4: locationFilters['นครปฐม'],
        p5: locationFilters['ปทุมธานี'],
      });
      setFetchLocationKey(computeLocationKey(locationFilters));
      setView_location_trigger((v) => v + 1);
    }
  }

  function limit_display(name, direction) {
    if (direction === 'next') {
      if (name === 'promotion') {
        var datamax = dataitem_filter_promotion.length - 1;
        var tmpmax = limit_promotion.max + 10;
        if (tmpmax <= datamax) {
          setLimit_promotion({ max: limit_promotion.max + 10, min: limit_promotion.min + 10 });
        } else {
          var avi = datamax - limit_promotion.max;
          if (avi >= 10) {
            avi = 10;
          }
          setLimit_promotion({ max: limit_promotion.max + avi, min: limit_promotion.min + avi });
        }
      } else if (name === 'bestseller') {
        var datamax = dataitem_filter_bestseller.length - 1;
        var tmpmax = limit_bestseller.max + 10;
        if (tmpmax <= datamax) {
          setLimit_bestseller({ max: limit_bestseller.max + 10, min: limit_bestseller.min + 10 });
        } else {
          var avi = datamax - limit_bestseller.max;
          if (avi >= 10) {
            avi = 10;
          }
          setLimit_bestseller({ max: limit_bestseller.max + avi, min: limit_bestseller.min + avi });
        }
      }
    } else {
      if (name === 'promotion') {
        var tmpmin = limit_promotion.min - 10;
        if (tmpmin >= 0) {
          setLimit_promotion({ max: limit_promotion.max - 10, min: limit_promotion.min - 10 });
        } else {
          setLimit_promotion({ max: 9, min: 0 });
        }
      } else if (name === 'bestseller') {
        var tmpmin = limit_bestseller.min - 10;
        if (tmpmin >= 0) {
          setLimit_bestseller({ max: limit_bestseller.max - 10, min: limit_bestseller.min - 10 });
        } else {
          setLimit_bestseller({ max: 9, min: 0 });
        }
      }
    }
  }

  const endOffset_onsell = itemOffset_onsell + 18;
  const currentItems_onsell = isPromotion
    ? dataitem_all
    : dataitem_filter_single.slice(itemOffset_onsell, endOffset_onsell);
  const pageCount_onsell = isPromotion
    ? Math.ceil(promotionTotal / 50)
    : Math.ceil(dataitem_filter_single.length / 18);
  const handlePageClick_onsell = (event) => {
    if (isPromotion) {
      setPromotionPage(event.selected + 1);
    } else {
      const newOffset_onsell = (event.selected * 18) % dataitem_filter_single.length;
      setItemOffset_onsell(newOffset_onsell);
      setDefaultPaginate(event.selected);
    }
  };

  const SAMPLE_ADS_COUNT = 20;
  const displayCount =
    view_productcategory_name === 'เพื่อโฆษณา' && dataitem_filter_single.length === 0
      ? SAMPLE_ADS_COUNT
      : dataitem_filter_single.length;

  function generate_token(length) {
    var a = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'.split('');
    var b = [];
    for (var i = 0; i < length; i++) {
      var j = (Math.random() * (a.length - 1)).toFixed(0);
      b[i] = a[j];
    }
    return b.join('');
  }

  return (
    <main id='content' role='main' className='marketplace-container'>
      <AdBanner />
      <div className='container'>
        <div className='row mb-8'>
          {/* Sidebar */}
          <div className='d-none d-lg-block marketplace-sidebar px-1'>
            <div className='sidebar-card'>
              <div className='sidebar-title font-th'>
                <i className='fe-package text-primary'></i> หมวดหมู่สินค้า
              </div>
              <ul className='sidebar-nav-list'>
                <li className='sidebar-nav-item'>
                  <Link
                    to={'/marketplace?category=สินค้าโปรโมชั่น&&transaction=' + generate_token(10)}
                    className={
                      'sidebar-nav-link font-th ' +
                      `${view_productcategory_name === 'สินค้าโปรโมชั่น' ? 'active' : ''}`
                    }
                  >
                    <span>สินค้าโปรโมชั่น</span>
                    {view_productcategory_name === 'สินค้าโปรโมชั่น' && <i className='fe-chevron-right'></i>}
                  </Link>
                </li>
                <li className='sidebar-nav-item'>
                  <Link
                    to={'/marketplace?category=สินค้าแนะนำ&&transaction=' + generate_token(10)}
                    className={
                      'sidebar-nav-link font-th ' +
                      `${view_productcategory_name === 'สินค้าแนะนำ' ? 'active' : ''}`
                    }
                  >
                    <span>สินค้าแนะนำ</span>
                    {view_productcategory_name === 'สินค้าแนะนำ' && <i className='fe-chevron-right'></i>}
                  </Link>
                </li>
                {props.systemdata_productcategorylist.map((element) => (
                  <li key={element.productcategory_id} className='sidebar-nav-item'>
                    <Link
                      to={
                        '/marketplace?category=' +
                        element.productcategory_name +
                        '&&transaction=' +
                        generate_token(10)
                      }
                      className={
                        'sidebar-nav-link font-th ' +
                        `${view_productcategory_name === element.productcategory_name ? 'active' : ''}`
                      }
                    >
                      <span>{element.productcategory_name}</span>
                      {view_productcategory_name === element.productcategory_name && <i className='fe-chevron-right'></i>}
                    </Link>
                  </li>
                ))}
              </ul>

              <div className='sidebar-divider'></div>

              <div className='sidebar-title font-th'>
                <i className='fe-map-pin text-primary'></i> สถานที่
              </div>
              <div className='location-filter-group'>
                {LOCATION_CONFIG.map((loc) => (
                  <label key={loc.id} className='location-checkbox' htmlFor={loc.id}>
                    <input
                      type='checkbox'
                      id={loc.id}
                      checked={locationFilters[loc.name]}
                      onChange={() => handleLocationCheckboxChange(loc.name)}
                    />
                    <span className='location-label'>{loc.name}</span>
                  </label>
                ))}

                <button
                  type='button'
                  className='btn btn-primary btn-block text-white mt-4 py-2 rounded-lg font-th shadow-sm'
                  onClick={() => loacation_begin_trigger()}
                >
                  <i className='fe-search mr-2'></i> ค้นหาตามพื้นที่
                </button>
              </div>
            </div>
          </div>

          {/* Main Content Area */}
          <div className='col d-block min-height-600 meya-content-100p market-content-card'>
            {/* Breadcrumbs */}
            <div className='mb-4 d-none d-md-block'>
              <nav aria-label='breadcrumb'>
                <ol className='breadcrumb bg-transparent p-0 mb-0'>
                  <li className='breadcrumb-item font-th'>
                    <Link to='/marketplace?category=รวมสินค้า' className='text-muted'>หน้าแรก</Link>
                  </li>
                  {view_productcategory_name === 'ค้นหาสินค้า' ? (
                    <>
                      <li className='breadcrumb-item font-th text-muted'>ค้นหาสินค้า</li>
                      <li className='breadcrumb-item font-th active text-primary'>
                        {view_searchtype_name === 'contain' ? view_searchtext_name : view_productid_name}
                      </li>
                    </>
                  ) : (
                    <li className='breadcrumb-item font-th active text-primary'>
                      {view_productcategory_name}
                    </li>
                  )}
                </ol>
              </nav>
            </div>

            {isJobOnlyLoggedIn && (
              <div 
                className='font-th mb-4 p-4 d-flex align-items-start' 
                style={{ 
                  background: 'var(--market-card-bg)', 
                  border: '1px solid var(--market-border)',
                  borderLeft: '4px solid #34a6f7',
                  borderRadius: 'var(--radius-lg)',
                  boxShadow: 'var(--market-shadow-sm)',
                  gap: '16px'
                }}
              >
                <div style={{ background: '#e0f2fe', padding: '10px', borderRadius: '12px' }}>
                  <i className='fas fa-info-circle' style={{ color: '#34a6f7', fontSize: '22px' }}></i>
                </div>
                <div className='flex-grow-1'>
                  <h5 className='font-weight-bold mb-1' style={{ color: 'var(--market-text-main)', fontSize: '17px' }}>
                    ข้อความแจ้งเตือน
                  </h5>
                  <p className='mb-3' style={{ fontSize: '14.5px', color: 'var(--market-text-muted)', lineHeight: '1.6' }}>
                    บัญชีหางานยังไม่สามารถดูหรือสั่งซื้อสินค้าได้ กรุณาเข้าสู่ระบบด้วยบัญชีร้านค้าเพื่อใช้งาน Marketplace
                  </p>
                  <button
                    type='button'
                    className='btn text-white font-weight-bold px-4 py-2'
                    style={{ 
                      background: '#34a6f7', 
                      border: 'none',
                      borderRadius: '8px', 
                      fontSize: '14px',
                      boxShadow: '0 4px 6px -1px rgba(52, 166, 247, 0.2)'
                    }}
                    onClick={() => {
                      sessionStorage.removeItem('meya-job-loggedin');
                      sessionStorage.removeItem('meya-job-username');
                      window.location.href = '/';
                    }}
                  >
                    เข้าสู่ระบบบัญชีร้านค้า
                  </button>
                </div>
              </div>
            )}

            {/* Content Logic */}
            {isJobOnlyLoggedIn ? null : view_productcategory_name === 'รวมสินค้า' ? (
              <div className='mt-2'>
                <div className={isHomeRefreshing ? 'market-home-refreshing' : ''}>
                {/* Promotion Section */}
                {dataitem_filter_promotion.length > 0 && (
                  <>
                    <div className='market-section-header'>
                      <h5 className='market-section-title'>สินค้าโปรโมชั่น</h5>
                      <Link className='view-more-link' to='/marketplace?category=สินค้าโปรโมชั่น'>
                        ดูทั้งหมด <i className='fe-arrow-right'></i>
                      </Link>
                    </div>
                    <div className='product-grid'>
                      {dataitem_filter_promotion.slice(limit_promotion.min, limit_promotion.max + 1).map((element) => (
                        <CardProduct
                          key={element.shopitem_id}
                          shopitem={element}
                          show_shop={true}
                          app_hostname={props.app_hostname}
                          disableLink={isJobOnlyLoggedIn}
                        />
                      ))}
                    </div>
                  </>
                )}

                {/* Best Seller Section */}
                {dataitem_filter_bestseller.length > 0 && (
                  <>
                    <div className='market-section-header'>
                      <h5 className='market-section-title'>สินค้าแนะนำ</h5>
                      <Link className='view-more-link' to='/marketplace?category=สินค้าแนะนำ'>
                        ดูทั้งหมด <i className='fe-arrow-right'></i>
                      </Link>
                    </div>
                    <div className='product-grid'>
                      {dataitem_filter_bestseller.slice(limit_bestseller.min, limit_bestseller.max + 1).map((element) => (
                        <CardProduct
                          key={element.shopitem_id}
                          shopitem={element}
                          show_shop={true}
                          app_hostname={props.app_hostname}
                          disableLink={isJobOnlyLoggedIn}
                        />
                      ))}
                    </div>
                  </>
                )}

                {/* Empty State / Sample Ads */}
                {dataitem_filter_promotion.length === 0 &&
                  dataitem_filter_bestseller.length === 0 &&
                  modal_load.enable === false &&
                  !isHomeRefreshing && (
                  view_productcategory_name === 'เพื่อโฆษณา' ? (
                    <div className='product-grid'>
                      {Array.from({ length: 12 }).map((_, i) => (
                        <CardProduct
                          key={`sample-${i}`}
                          shopitem={{
                            shopitem_id: `sample-${i}`,
                            productitem_id: `s-${i}`,
                            productitem_name: `สินค้าตัวอย่าง ${i+1}`,
                            productitem_inter: 'รายละเอียดตัวอย่างสินค้า',
                            first_priceunit: 'ชิ้น',
                            first_pricebase: 100,
                            shop_name: 'ร้านค้าตัวอย่าง',
                            shop_province: 'กรุงเทพฯ',
                            ads: true
                          }}
                          disableLink={true}
                        />
                      ))}
                    </div>
                  ) : (
                    <div className='noproductdisplay py-5'>
                      <i className='fas fa-info-circle text-primary mb-3' style={{ fontSize: '2rem' }}></i>
                      <div>ไม่พบสินค้าที่ต้องการ ลองเปลี่ยนคำค้นหาหรือสถานที่นะคะ</div>
                    </div>
                  )
                )}
                </div>
              </div>
            ) : (
              /* Paginated List View (Category / Search) */
              <>
                <div className='market-section-header mt-2'>
                  <h5 className='market-section-title'>
                    {view_productcategory_name === 'ค้นหาสินค้า' ? 'ผลการค้นหา' : view_productcategory_name}
                  </h5>
                  <span className='text-muted font-th font-size-14'>
                    {displayCount} รายการ
                  </span>
                </div>

                <div className='product-grid mt-4'>
                  {currentItems_onsell.map((element) => (
                    <CardProduct
                      key={element.shopitem_id}
                      shopitem={element}
                      show_shop={true}
                      app_hostname={props.app_hostname}
                      disableLink={isJobOnlyLoggedIn}
                    />
                  ))}
                </div>

                {/* Pagination */}
                {pageCount_onsell > 1 && (
                  <div className='modern-pagination-container mt-5'>
                    <ReactPaginate
                      breakLabel='...'
                      nextLabel='>'
                      onPageChange={handlePageClick_onsell}
                      pageRangeDisplayed={5}
                      pageCount={pageCount_onsell}
                      previousLabel='<'
                      renderOnZeroPageCount={null}
                      forcePage={view_defaultpaginate}
                      containerClassName='modern-pagination'
                    />
                  </div>
                )}

                {currentItems_onsell.length === 0 && modal_load.enable === false && (
                  <div className='noproductdisplay py-5'>
                    {isCategoryView && !canBrowseCategory ? (
                      <>
                        <i className='fas fa-lock text-warning mb-3' style={{ fontSize: '2.5rem' }}></i>
                        <h5 className='font-weight-bold text-dark mb-2'>ท่านยังไม่ได้รับสิทธิ์ในการเข้าถึงสินค้าในหมวดหมู่นี้</h5>
                        <div className='text-muted mb-3'>
                          หากต้องการขอเปิดสิทธิ์การสั่งซื้อในหมวดหมู่นี้ กรุณาติดต่อเจ้าหน้าที่ดูแลระบบ
                        </div>
                        <a
                          href='https://lin.ee/G3gOv00'
                          target='_blank'
                          rel='noopener noreferrer'
                          className='btn btn-outline-success font-th px-4 py-2'
                          style={{ borderRadius: '8px', fontWeight: '500' }}
                        >
                          <i className='fab fa-line mr-2' style={{ fontSize: '1.2rem', verticalAlign: 'middle' }}></i>
                          ติดต่อ Line OA: @meya
                        </a>
                      </>
                    ) : (
                      <>
                        <i className='fas fa-info-circle text-primary mb-3' style={{ fontSize: '2rem' }}></i>
                        <div>ไม่พบสินค้าที่ต้องการในหมวดหมู่นี้ค่ะ</div>
                      </>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <ModalLoad option={modal_load} backdrop={true} />
      <ModalPopupMessage
        callback_general={(message) => showDialogCallback_General(message)}
        callback_confirm={(message) => showDialogCallback_Confirm(message)}
        options={modal_popup}
      />
      <BtnGogo />
    </main>
  );
}

export default MarketPlace;
